import { store, authActions } from '_store';

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
};

function request(method) {
    return (url, body) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';
            requestOptions.body = JSON.stringify(body);
        }
        return fetch(url, requestOptions).then(handleResponse);
    }
}

// helper functions

function authHeader(url) {
    // return auth header with jwt if user is logged in and request is to the api url
    const token = authToken();
    const isLoggedIn = !!token;
    const apiRoots = [process.env.REACT_APP_API_URL, process.env.REACT_APP_URL]
        .filter(Boolean);
    const isApiUrl = apiRoots.some((root) => url.startsWith(root));
    if (isLoggedIn && isApiUrl) {
        return { Authorization: `Bearer ${token}` };
    } else {
        return {};
    }
}

function authToken() {
    return store.getState().auth.user?.token;
}

function handleResponse(response) {
    return response.text().then(text => {
        let data = null;
        try {
            data = text ? JSON.parse(text) : null;
        } catch {
            data = text;
        }
        // console.log('handleResponse wrapper response: ')
        // console.log(response)

        if (!response.ok) {
            if ([401, 403].includes(response.status) && authToken()) {
                store.dispatch(authActions.logout());
            }

            const error = (data && typeof data === 'object' && (
                data.message
                || data.Error
                || data.error
                || data['Login Error: ']
            )) || (typeof data === 'string' && data) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}